var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlotter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.89543 0.895431 0 2 0H22C23.1046 0 24 0.895431 24 2V22C24 23.1046 23.1046 24 22 24H2C0.89543 24 0 23.1046 0 22V2ZM22 7.44466V8.7515V9.97816C22 9.97816 20.1999 10 19.619 10H11.5469H6.7619H2C2 10 4.86504 7.06565 7 5.15778L7.24355 4.93993C8.61134 3.71597 10.5287 2.00021 11 2C11.5 1.99978 11.5048 2.87427 11.5 3.61435C11.4952 4.35444 11.5 6.23362 11.5 6.23362H20C20.07 6.23362 20.1434 6.23239 20.219 6.23113C20.9918 6.21825 22 6.20144 22 7.44466ZM2 15.2485V16.5553C2 17.7986 3.00824 17.7818 3.78098 17.7689C3.85663 17.7676 3.93003 17.7664 4 17.7664H12.5C12.5 17.7664 12.5048 19.6456 12.5 20.3856C12.4952 21.1257 12.5 22.0002 13 22C13.4713 21.9998 15.3886 20.284 16.7564 19.0601C16.8398 18.9855 16.9212 18.9127 17 18.8422C19.135 16.9343 22 14 22 14H17.2381H12.4531H4.38095C3.80011 14 2 14.0218 2 14.0218V15.2485Z",
    fill: "#BABEC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlotter);
export default __webpack_public_path__ + "static/media/blotter.f29053e6b6c9859936d043dc97d8b613.svg";
export { ForwardRef as ReactComponent };